import React from "react";
import ContactMainComponent from "@/features/contacts/components/ContactMainComponent";

const Contacts = () => {
  return <ContactMainComponent />;
};

export default Contacts;
